<template>
  <div class="form-login">
    <div
      class="form-login__alert"
      v-if="user.isInvalid"
    >
      {{ error || 'Erro de autenticação'}} :(
    </div>

    <form
      :class="{ 'disabled': isLoading }"
      @submit.prevent="formSubmit"
    >
      <label>
        E-mail
        <input
          type="email"
          required
          autofocus
          v-model="user.email"
        >
      </label>

      <label>
        Senha
        <div class="form-login__input-icon form-login__input-icon--link">
          <input
            :type="passwordVisible ? 'text' : 'password'"
            required
            v-model="user.password"
          >

          <FontAwesomeIcon
            :icon="passwordVisible ? 'eye' : 'eye-slash'"
            @click.prevent="passwordVisible = !passwordVisible"
          />
        </div>
      </label>

      <div class="form-login__action">
        <button :class="{ 'on': isLoading }">
          <FontAwesomeIcon
            icon="circle-notch"
            spin
            v-if="isLoading"
          />

          <FontAwesomeIcon
            icon="long-arrow-alt-right"
            v-else
          />
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import Axios from 'axios'
import { mapState, mapGetters, mapMutations } from 'vuex'
import decode from 'jwt-decode'

export default {
  name: 'BoxLogin',

  data () {
    return {
      isLoading: false,
      passwordVisible: false,
      user: {
        email: '',
        password: '',
        isInvalid: false
      },
      error: null
    }
  },

  computed: {
    ...mapState('auth', ['isSignIn']),
    ...mapGetters('auth', ['usersAll'])
  },

  methods: {
    ...mapMutations('auth', [
      'SET_IS_SIGN_IN',
      'SET_USER_PROFILE'
    ]),

    formSubmit () {
      this.isLoading = true
      this.passwordVisible = false
      this.user.isInvalid = false

      setTimeout(() => {
        this.signIn()
        this.isLoading = false
      }, 2000)
    },

    signIn () {
      const data = { email: this.user.email, password: this.user.password }
      this.error = null
      Axios.post(`${process.env.VUE_APP_NEW_API}/auth/login`, data)
        .then((res) => {
          const decoded = decode(res.data.data.accessToken)
          this.SET_USER_PROFILE({
            name: decoded.name,
            email: decoded.email,
            id: decoded.id,
            roles: decoded.roles,
            token: res.data.data.accessToken
          })
          this.SET_IS_SIGN_IN(true)
          this.$router.push({ name: 'loggedVideos' })
        })
        .catch(() => {
          this.user.isInvalid = true
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.form-login {
  &__alert {
    padding-bottom: 30px;
    color: map-get($color-util, 'warning');
    font-weight: 700;
  }

  label {
    display: block;
    margin-bottom: 30px;
    transition: all 0.1s;
    color: rgba(white, 0.5);
    font-size: 0.9rem;
    line-height: 140%;
    text-align: left;

    &:focus-within {
      color: white;
    }
  }

  input:not([type="hidden"]) {
    display: block;
    width: 100%;
    padding: 10px;
    margin-top: 5px;
    border: 1px solid rgba(white, 0.5);
    border-radius: 2px;
    outline: 0;
    transition: all 0.1s;
    background: none;
    color: white;
    font: {
      size: 0.9rem;
      family: $font-regular;
    }

    &:focus {
      border-color: white;
    }
  }

  &__input-icon {
    position: relative;

    &--link {
      svg {
        cursor: pointer;

        &:hover {
          color: white;
        }
      }
    }

    input:not([type="hidden"]) {
      padding-right: 40px;
    }

    svg {
      position: absolute;
      top: 50%;
      right: 10px;
      transform: translateY(-50%);
      transition: color 0.1s;
      font-size: 15px;
    }
  }

  &__action {
    display: flex;
    justify-content: flex-end;
    align-items: center;

    ul {
      li {
        display: inline-block;
        color: map-get($color-util, 'dark');

        &:nth-child(n + 2) {
          &::before {
            content: '|';
            margin: 0 10px;
          }
        }
      }

      a {
        color: map-get($color-util, 'light');
        font-size: 0.8rem;

        &:hover {
          color: white;
        }
      }
    }

    button {
      $size: 60px;

      display: inline-block;
      width: $size;
      height: $size;
      border: 0;
      border-radius: $size;
      outline: 0;
      transition: all 0.1s;
      background: rgba(#000, 0.2);

      &:hover,
      &:focus,
      &.on {
        transform: scale(1.2);
        background: rgba(#000, 0.4);

        svg {
          color: white;
        }
      }

      svg {
        transition: all 0.1s;
        color: rgba(white, 0.5);
        font-size: 15px;
      }
    }
  }

  // Responsiveness
  @include media(map-get($breakpoint, 'medium')) {
    &__action {
      flex-direction: column-reverse;

      ul {
        margin-top: 40px;
      }
    }
  }
}
</style>
